import * as React from "react";
import cssExports from "theme/styles/main.module.scss";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";
import clsx from "clsx";
import { Grid } from "@mui/material";

function usePlaceholder(label: string, placeholder?: string, optional?: boolean) {
  const [placeholderOut, setPlaceholder] = React.useState<string | React.ReactElement>();
  const [placeholderText, setPlaceholderText] = React.useState<string>();

  React.useEffect(() => {
    if (placeholder) {
      const placeholderTr = LocalizationHelperInstance.getFormattedMessage(placeholder, placeholder);
      if (placeholderText !== placeholderTr) {
        setPlaceholder(placeholderTr);
        setPlaceholderText(placeholderTr);
      }
    } else if (optional) {
      const labelTr = label ? LocalizationHelperInstance.getFormattedMessage(label, label) : "";
      if (placeholderText !== `${labelTr}${optional ? "optional" : ""}`) {
        setPlaceholder(
          <Grid container direction={"row"} className={cssExports.labelText}>
            <Grid item className={cssExports.truncateString}>
              {labelTr}
            </Grid>
            <Grid item xs={"auto"}>
              <span
                className={clsx(cssExports.optionalText, UtilsHelper.isEmpty(labelTr) ? cssExports.noMargin : "")}
              >{`(${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Optional)})`}</span>
            </Grid>
          </Grid>
        );
        setPlaceholderText(`${labelTr}${optional ? "optional" : ""}`);
      }
    } else {
      if (placeholderText !== undefined) {
        setPlaceholder(undefined);
        setPlaceholderText(undefined);
      }
    }
  });

  return placeholderOut;
}

export default usePlaceholder;
